import HistoryRow from 'Components/HistoryRow';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import { calculateDaysDifference, isNumber } from 'neuro-utils';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { sortDocumentsDescending } from 'Utility/documentHandling';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'sleepApneaFirstVisit'>[] = [];
const FirstVisitSleepApneaHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'sleepApneaFirstVisit'>>): React.JSX.Element => {
  const fvsa = documents.toSorted(sortDocumentsDescending).at(0);

  const daysDifference = calculateDaysDifference(fvsa?.dateOfReferral, fvsa?.dateOfFirstVisit);

  return (
    <HistoryRow
      headerText={fm('diagnosis.sleepApnea.sleepApneaFirstVisit.title')}
      rowButton={
        startEdit
          ? newButton(
              'sleepApneaFirstVisit',
              startEdit(fvsa ?? {}, 'sleepApneaFirstVisit'),
              'general.edit',
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              fvsa,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(fvsa)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('diagnosis.sleepApnea.sleepApneaFirstVisit.referralOrAcute')}
          value={fvsa?.referralOrAcute && fm('diagnosis.sleepApnea.sleepApneaFirstVisit.opts.' + fvsa.referralOrAcute)}
        />
        {fvsa?.referralOrAcute === 'referral' && (
          <>
            <HistoryRowVerticalItem
              header={fm('diagnosis.sleepApnea.sleepApneaFirstVisit.dateOfReferral')}
              value={fvsa.dateOfReferral ? formatPartialDate(fvsa.dateOfReferral) : undefined}
            />
            <HistoryRowVerticalItem
              header={fm('diagnosis.sleepApnea.sleepApneaFirstVisit.dateOfFirstVisit')}
              value={fvsa.dateOfFirstVisit ? formatPartialDate(fvsa.dateOfFirstVisit) : undefined}
            />
            <HistoryRowVerticalItem
              header={fm('diagnosis.sleepApnea.sleepApneaFirstVisit.delayFromArrivalToFirstVisit')}
              value={isNumber(daysDifference) ? `${daysDifference} ${fm('diagnosis.sleepApnea.days')}` : undefined}
            />
          </>
        )}
      </React.Fragment>
    </HistoryRow>
  );
};

export default FirstVisitSleepApneaHistory;
